﻿import { LogMsg } from "./LogMsg";
import { EnumLogLevel } from "./EnumLogLevel";

export class AppLog {
    static LogMsgList = new Array<LogMsg>();
    static MaxSizeArray = 1500;
    static NewSizeArray = 1000;

    static logInfo(source: string, msg: string = "") {
        this.log(source, EnumLogLevel.Info, msg);
    }

    static logError(source: string, msg: string = "") {
        this.log(source, EnumLogLevel.Error, msg);
    }

    static formatTimestamp(date: Date): string {
        const pad = (n: number) => String(n).padStart(2, '0');
        const ms = String(date.getMilliseconds()).padStart(3, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${ms}`;
    }

    static clear() {
        AppLog.LogMsgList = new Array<LogMsg>();
    }


    private static log(source: string, level: EnumLogLevel = EnumLogLevel.Info, msg: string = "") {
        const logMsg = new LogMsg();
        logMsg.Source = source;
        logMsg.Level = level;
        logMsg.Message = msg;
        // ReSharper disable once TsResolvedFromInaccessibleModule
        logMsg.MessageTime = AppLog.formatTimestamp(new Date());

        console.log(`${logMsg.MessageTime} [${EnumLogLevel[level]}] ${source} ${msg}`);

        AppLog.LogMsgList.push(logMsg);

        if (AppLog.LogMsgList.length > AppLog.MaxSizeArray) {
            const newArray = AppLog.LogMsgList.slice(AppLog.MaxSizeArray - AppLog.NewSizeArray, AppLog.MaxSizeArray);
            AppLog.LogMsgList = newArray;

            this.logInfo("Log verkleinert");
        }
    }
}
